import React from "react";
import { ClipboardListIcon, StethoscopeIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
import { Countdown } from "./Countdown";
import { ScarcityBar } from "./ScarcityBar";
import { CurrencyNote } from "./CurrencyNote";
import { images, PRICE, TOTAL_VALUE } from "../data/offer";
export function Hero() {
  return <header className="bg-navy-950 text-white" data-id="element-202" data-mp="4n9wof0e3a1l">
      <div className="bg-alert px-4 py-2.5 text-center text-sm font-semibold" data-id="element-203" data-mp="1297f6cerrfdj">
        Special offer today: the complete blueprint for just ${PRICE}
      </div>

      <div className="mx-auto grid max-w-6xl gap-6 px-4 pb-16 pt-8 sm:px-6 lg:grid-cols-2 lg:gap-x-14 lg:pt-16" data-id="element-204" data-mp="x8b85pz4fd3w">
        <div className="lg:col-start-1" data-id="element-205" data-mp="sd4c94c3fcpj">
          <p className="font-display text-lg font-semibold uppercase tracking-wide text-accent sm:text-xl" data-id="element-206" data-mp="nb6k1klpt7kg">
            Diabetic Foot Assessment Blueprint™
          </p>
          <h1 className="mt-3 font-display text-[2.35rem] font-bold uppercase leading-[1.04] sm:text-5xl lg:text-[3.6rem]" data-id="element-207" data-mp="382p5xe0y1flo">
            Build a structured diabetic foot assessment <span className="text-cta" data-id="element-208" data-mp="3j6fylr125fed">in 15 minutes</span>
          </h1>
          <p className="mt-4 text-lg font-medium text-white/90 sm:text-xl" data-id="element-209" data-mp="3o6ar1z0hed1j">
            With a practical, step-by-step clinical reference.
          </p>
        </div>

        <div className="-mx-4 sm:mx-0 lg:col-start-2 lg:row-span-2 lg:row-start-1 lg:self-center" data-id="element-210" data-mp="3e8wjyq0g70lw">
          <img src={images.mockup} alt="Diabetic Foot Assessment Blueprint 6-volume collection with 5 bonuses" className="mx-auto w-full max-w-2xl" data-id="element-211" data-mp="30hhnphhj52ww" />
        </div>

        <div className="lg:col-start-1" data-id="element-212" data-mp="2qkmt39odnmnw">
          <p className="text-base leading-relaxed text-white/80 sm:text-lg" data-id="element-213" data-mp="2qlod43ndfjhr">
            A comprehensive educational reference designed to help you organize diabetic foot assessments, review
            important risk factors, document clinical findings, and recognize situations that may require further
            evaluation.
          </p>

          <dl className="mt-6 grid grid-cols-2 gap-3" data-id="element-214" data-mp="s2jn3wuh80ji">
            <Stat lead="6" label="In-depth volumes" data-id="element-215" data-mp="s44hnmgsjjhd" />
            <Stat lead="5" label="Specialized bonuses" data-id="element-216" data-mp="nb1jf112jluu" />
            <Stat icon={<ClipboardListIcon className="h-7 w-7" aria-hidden="true" data-id="element-218" data-mp="ic87hd1fk2ws" />} label="Checklists & templates" data-id="element-217" data-mp="n9i4pev29iv6" />
            <Stat icon={<StethoscopeIcon className="h-7 w-7" aria-hidden="true" data-id="element-220" data-mp="ddng8345otkh" />} label="Clinical case exercises" data-id="element-219" data-mp="ddf2k907lk88" />
          </dl>

          <div className="mt-8 text-center lg:text-left" data-id="element-221" data-mp="1azullf8aapxw">
            <p className="text-base text-white/70" data-id="element-222" data-mp="161t0ypv7mikb">
              Total reference value <span className="line-through" data-id="element-223" data-mp="15zq2dhfzrh3z">${TOTAL_VALUE}</span>
            </p>
            <p className="font-display text-2xl font-bold uppercase" data-id="element-224" data-mp="11152jj4nizg2">
              Get the complete blueprint — just{" "}
              <span className="text-5xl text-cta sm:text-6xl" data-id="element-225" data-mp="x3h3c3vxekid">${PRICE}</span>
            </p>
          </div>
        </div>
      </div>

      <div className="mx-auto -mt-8 flex max-w-6xl flex-col gap-8 px-4 pb-16 sm:px-6" data-id="element-226" data-mp="3hqu2ybi9aa1p">
        <CtaButton id="hero-cta" label={`Get the blueprint — $${PRICE}`} microcopy="Instant digital access · One-time payment · No monthly fees · Educational reference for healthcare professionals" tone="dark" data-id="element-227" data-mp="1x9kugm9v74h7" />
        <Countdown data-id="element-228" data-mp="268odxrcy1lw8" />
        <ScarcityBar data-id="element-229" data-mp="26867y30hbtb4" />
        <CurrencyNote data-id="element-230" data-mp="2b0fz1mdbyzez" />
      </div>
    </header>;
}
type StatProps = {
  lead?: string;
  icon?: React.ReactNode;
  label: string;
};
function Stat({
  lead,
  icon,
  label
}: StatProps) {
  return <div className="flex items-center gap-3 rounded-xl bg-white/[0.07] px-3 py-3" data-id="element-231" data-mp="2kyn9dmd46j80">
      <dt className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-accent font-display text-3xl font-bold text-navy-950" data-id="element-232" data-mp="2l0qbh4rjk2t3">
        {lead ?? icon}
      </dt>
      <dd className="text-sm font-semibold leading-snug text-white" data-id="element-233" data-mp="2tysgrwib5hm6">{label}</dd>
    </div>;
}